<template>
    <div :style="cssProps">
        <div
            v-if="title.trim().length"
            :class="['title-input ', titleExclusive ? 'title-exclusive' : '']"
        >
            {{ title }}
            <font-awesome-icon
                v-if="rules.required && !titleExclusive"
                :icon="['fas', 'circle']"
                class="icon-font"
            />
        </div>
        <div class="input-component">
            <span v-if="hasIcon" :style="`color: ${focus.target ? focus.color : ''}`" class="icon">
                <i :class="`${icon}`"></i>
            </span>
            <label v-if="link" class="link-input">https://</label>
            <span
                v-if="hasMoney"
                :style="`color: ${focus.target ? focus.color : ''}`"
                class="icon"
            >R$</span>
            <input
                :disabled="disabled"
                v-bind:v-model="value"
                :value="value"
                :type="inputType"
                :style="{
                    'background-color': disabled ? '#F2F2F2' : backgroundColor,
                    color: disabled ? '#A5A5A5' : '#000'
                }"
                v-money="validateMoney()"
                v-mask="validateMask(mask)"
                v-on:input="$emit('input', $event.target.value)"
                :placeholder="placeholderText"
                :class="[{ calendar: calendar }, 'browser-default text-input', { 'has-icon': hasIcon || hasMoney }]"
                @focus="focusInput"
                @blur="focusInput(), validate(), $emit('onblur'), viaCepRequest()"
                @click="$emit('click')"
                v-on:keyup.enter="$emit('enter', true)"
            />
        </div>
        <transition name="slide-fade">
            <p style="color: red" v-if="show">{{ messageError }}</p>
        </transition>
    </div>
</template>

<script>
import 'flatpickr/dist/flatpickr.css';
import flatpickr from 'flatpickr';
import cep from 'cep-promise';
import { validateInput } from '@/utils/rules/input';
export default {
    props: {
        valid: { type: Boolean, default: false },
        hasMoney: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        calendar: {
            type: Boolean,
            default: false
        },
        link: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        validateCep: {
            type: Boolean,
            default: false
        },
        inputType: {
            type: String,
            default: 'text'
        },
        icon: {
            type: String,
            default: ''
        },
        rules: {
            type: Object,
            default: () => ({})
        },
        configCalendar: Object,
        placeholderText: {
            type: String,
            default: ''
        },
        hasIcon: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        backgroundColor: {
            type: String,
            default: '#FFF'
        },
        focusColor: {
            type: String,
            default: '#a5a5a5'
        },
        mask: {
            type: Array,
            default: () => []
        },
        titleExclusive: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false 
        },
        errorMessage: {
            type: String,
            default: ''
        }
    },
    methods: {
        validateMoney () {
            return this.hasMoney ? this.money : false;
        },
        async viaCepRequest () {
            try {
                if (this.validateCep) {
                    const data = await cep(this.value);
                    if (Object.keys(data).length) {
                        this.$emit('validate-cep', data);
                    }
                }
            } catch (e) {
                this.messageError = 'CEP inválido';
                this.focus.color = 'red';
                this.show = true;
                this.$emit('valid', !this.show);
            }
        },
        validateMask (mask) {
            return mask.length ? mask : this.noMask;
        },
        focusInput () {
            this.focus.color = this.show ? 'red' : this.focusColor;
            if (this.focus.target) {
                this.focus.target = false;
            } else {
                this.focus.target = true;
            }
        },
        validate () {
            if (!Object.keys(this.rules).length) {
                return false;
            }
            this.messageError = validateInput(this.rules, this.value);
            if (this.messageError.trim('').split('').length) {
                this.sucess = false;
                this.focus.color = '#ED4F4F';
                this.show = true;
            } else {
                this.focus.color = '';
                this.show = false;
                this.sucess = true;
            }
            this.$emit('valid', !this.show);
        },
        validateError() {
            if(this.errorMessage.length > 0) {
                this.messageError = this.errorMessage;
                this.show = true;
                this.sucess = false;
            } else {
                this.messageError = this.errorMessage;
                this.show = false;
                this.sucess = true; 
            }
        }
    },
    computed: {
        styleProps () {
            return `
                'background-color': ${this.backgroundColor};
                input:focus {
                    border: 1px solid #a5a5a5 !important;
                    box-shadow: 0 0 0 0 #a5a5a5 !important;
            }`;
        },
        currencyMask () {
            return this.maskType == 'currency' || this.maskType == 'float' ? this.valueMask : undefined;
        },
        cssProps () {
            return {
                '--paddingLeftLink': this.link ? '75px' : '18px',
                '--hasMoney': this.hasMoney ? 'right' : 'none',
                '--hasMoneyPadding': this.hasMoney ? '20px' : '0px',
                '--fontWeigthIcon': this.hasIcon ? '600' : '0',
                '--leftLink': this.link ? '0px' : '18px',
                '--colorInput': this.show ? 'red' : this.focusColor,
                '--colorCircle': this.show ? 'red' : '#007BFF',
                '--colorCircleText': this.show ? 'red' : 'none',
                '--borderColor': this.sucess ? '#68CE6C' : '#dbdbdb',
                '--focusColor': !this.disabled ? '1px solid #0ca0fd' : '1px solid #dbdbdb',
                '--focusShadowBox': !this.disabled // ? "0px 1px 6px #0ca0fd2e"
                    ? 'none'
                    : 'none'
            };
        }
    },
    watch: {
        valid: {
            deep: true,
            handler () {
                this.validate();
            }
        },
        value: {
            deep: true,
            handler () {
                if (this.calendar) this.validate();
            }
        },
        error: {
            deep: true,
            handler () {
                this.validateError();
            }
        }
    },
    data: () => ({
        show: false,
        sucess: false,
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        },
        valueMask: {
            decimal: ',',
            masked: false,
            precision: 2,
            prefix: '',
            thousands: '.'
        },
        noMask: {
            mask: '*'.repeat(255),
            tokens: {
                '*': { pattern: /./ }
            }
        },
        focus: {
            target: false,
            color: ''
        },
        messageError: ''
    }),
    created () {
        this.valueMask.prefix = this.maskType == 'currency' ? 'R$ ' : '';
    },
    mounted () {
        if (this.calendar) {
            const config = this.configCalendar;
            flatpickr('.calendar', config);
        }
    }
};
</script>
<style scoped>
/* input {

} */
.row .input-field input:focus,
input.unit-price:focus,
.input-field textarea:focus,
.input-field input:focus {
    border-bottom: 1px var(--colorInput) solid !important;
    box-shadow: 0 0 0 0 !important;
}
/* Remover estilo do jquery  */
.input-field.col label {
    left: 0;
}
.input-field label {
    transform: inherit;
}
.input-field label:not(.label-icon).active {
    transform: initial;
    transform-origin: initial;
}
label.active {
    color: #a5a5a5 !important;
}
</style>
<style>
.title-input {
    margin-left: 5px;
    margin-bottom: 5px;
    font-size: 14px;
    color: var(--colorCircleText);
}
.title-input.title-exclusive {
    margin-left: 5px;
    margin-bottom: 5px;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */

    display: flex;
    align-items: center;

    /* #707070 */

    color: #707070;
}
.input-component .link-input {
    background-color: #dbdbdb;
    color: #a5a5a5;
    padding-left: 8px;
    padding-right: 8px;
    /* padding-top: 6px; */
}
.icon-font {
    font-size: 12px;
    padding-left: 5px;
    padding-bottom: 1px;
    color: var(--colorCircle);
}
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
.input-component {
    --input-height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    /* padding-bottom: 10px; */
}
.input-component input:hover {
    border: var(--focusColor);
    box-shadow: var(--focusShadowBox);
}
.input-component .text-input {
    border: 1px solid var(--borderColor);
    border-radius: 3px;
    padding: 0;
    padding-left: var(--paddingLeftLink);
    line-height: var(--input-height);
    width: 100%;
}
.input-component .text-input:focus {
    outline: none;
}
.row .input-field input:focus,
input.unit-price:focus,
.input-field input:focus {
    border: 1px solid var(--colorInput) !important;
    /* box-shadow: 1px 1px 1px 1px var(--colorInput) !important; */
}
/* .input-component input:focus + i {
    color:red!important;
} */
.input-component .text-input::placeholder {
    color: #a5a5a5;
    font-size: 14px;
    line-height: 19px;
}
.input-component .text-input.has-icon {
    padding-left: 54px;
    text-align: var(--hasMoney) !important;
    padding-right: var(--hasMoneyPadding) !important;
}
.input-component .icon {
    position: absolute;
    left: var(--leftLink);
    color: #a5a5a5;
    font-weight: var(--fontWeigthIcon) !important;
}

@media screen and (max-width: 1920px) {
    .input-component .link-input {
        padding-top: 11px;
    }
}

@media screen and (max-width: 1366px) {
    .input-component .link-input {
        padding-top: 8px;
    }
    .input-component {
        --input-height: 38px;
    }
}
@media screen and (max-width: 992px) {
}
</style>
